export default __webpack_public_path__ + "static/media/mint_score_background.6c99db84.png";